import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [RouterLink, TranslateModule],
  selector: 'app-not-found',
  standalone: true,
  styleUrls: ['./not-found.component.scss'],
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent {
  constructor() {}
}
